import { getDictPhrase } from "../getDictPhrase";
export const getNameOU = (outcomeType, dict) => {
    return getDictPhrase(dict, `AmericanBtn${outcomeType}`);
};
//# sourceMappingURL=getNameOU.js.map